import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, ModalController, LoadingController, AlertController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BuscarPessoaPage } from '../buscar-pessoa/buscar-pessoa.page';
import { EventoProvider } from 'src/app/services/evento/evento';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';

@Component({
  selector: 'app-reposicao-add',
  templateUrl: './reposicao-add.page.html',
  styleUrls: ['./reposicao-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NomenclaturaPipe,
    TranslateModule
  ],
})
export class ReposicaoAddPage implements OnInit {
  loader = this.loadingController.create({
    message: this.translate.instant("Carregando")
  });
  loaded: any = false;
  idEncontro: any;
  idEvento: any;
  idModulo: any;
  idAula: any;
  isAvulso: any;
  ensinos: any = [];
  ensinoReposicao: any;
  alert: any = false;
  inscritos: any = [];
  idPessoa: any;
  message: any;
  // pessoa: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public alertCtrl: AlertController,
    public eventoProvider: EventoProvider,
    public userProvider: UserProvider
  ) {
    this.idEncontro = this.navParams.get('idEncontro');
    this.idEvento = this.navParams.get('idEvento');
    this.idModulo = this.navParams.get('idModulo');
    this.idAula = this.navParams.get('idAula');
    this.isAvulso = this.navParams.get('isAvulso');
  }

  ngOnInit() {
    this.eventoProvider.getEnsinosReposicao(this.idAula, this.idModulo, this.idEvento).subscribe((data) => {
      this.ensinos = data;
      this.loaded = true;
    });
  }

  changeEnsino() {
    if (this.ensinoReposicao) {
      this.alert = false;
      this.inscritos = [];
      this.idPessoa = null;
      this.eventoProvider.getInscritosEnsino(this.idEvento, this.ensinoReposicao).subscribe((data) => {
        this.inscritos = data;
        if (!this.inscritos.length) {
          this.alert = true;
          this.message = 'Nenhuma pessoa encontrada';
        }
      });
    }
  }

  async selecionarPessoa() {
    var dataPessoa = { 'buscarGeral': true };
    var modalPessoa = await this.modalCtrl.create({ component: BuscarPessoaPage, componentProps: dataPessoa });
    modalPessoa.present();

    const pessoa = (await modalPessoa.onWillDismiss())
    if (pessoa.data) {
      this.changePessoa(pessoa.data.pessoa.id);
    }
  }

  changePessoa(idPessoa: any) {
    this.alert = false;
    this.inscritos = [];
    this.ensinoReposicao = null;
    this.idPessoa = null;
    this.eventoProvider.validaPessoaReposicao(this.idAula, idPessoa, this.idEvento).subscribe((data) => {
      if (data.error) {
        this.alert = true;
        this.message = data.message;
        this.idPessoa = null;
      } else {
        this.idPessoa = idPessoa;
        this.ensinoReposicao = data.idEvento;
      }
    });
  }

  salvar() {
    this.eventoProvider.salvarReposicao(this.ensinoReposicao, this.idPessoa, this.idEncontro, this.idAula).subscribe((data) => {
      this.modalCtrl.dismiss(true);
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}

